/**
 * Estado de rede, como hook.
 *
 * `navigator.onLine` é a única fonte que o navegador oferece e ela é
 * otimista: diz "online" para Wi-Fi de aeroporto que não entrega pacote. Serve
 * para o que precisamos — desabilitar ações que **sabidamente** não funcionam
 * sem rede. Para o resto, quem decide é a resposta do servidor.
 */
import { useEffect, useState } from 'react';

export function useOnline(): boolean {
  const [online, setOnline] = useState(
    () => typeof navigator === 'undefined' || navigator.onLine !== false,
  );

  useEffect(() => {
    const ligar = () => setOnline(true);
    const desligar = () => setOnline(false);

    window.addEventListener('online', ligar);
    window.addEventListener('offline', desligar);
    return () => {
      window.removeEventListener('online', ligar);
      window.removeEventListener('offline', desligar);
    };
  }, []);

  return online;
}
